import MainServices from "./Main.services";
import GenderAgeModel from "../model/GenderAge.model.txt";
import { createPromise } from "../utils/MainHelper";
import TrackFeatureServices from "./TrackFeature.services";

class SqreemAIServices {
    constructor() {
        this.aiurl = "nlp/oi/";
    }

    uploadRequestToS3(fileName, requestBody) {
        const path = `sqreemai/request/${fileName}.json`;
        return MainServices.uploadFile(path, JSON.stringify(requestBody), {}, "dashboard").then(
            () => path
        );
    }

    getResponse(id) {
        const { promise, resolve } = createPromise();
        const runPoll = () => {
            setTimeout(() => {
                return MainServices.get({ path: this.aiurl.replace("oi/", "") + id, options: { noCredentials: true } }).then((resp) => {
                    if (resp?.status === "Done") {
                        resolve(resp);
                    } else if (resp?.status === "Error") {
                        resolve();
                    } else {
                        runPoll();
                    }
                });
            }, 2000);
        };
        runPoll();
        return promise;
    }

    async runAPi(requestBody) {
        const guid = await MainServices.getGUID();
        let newRequestBody = { ...requestBody, s3id: guid };
        if (JSON.stringify(requestBody).length > 260144) {
            const s3Path = await this.uploadRequestToS3(
                newRequestBody._function + "~~" + guid,
                newRequestBody
            );
            newRequestBody = {
                s3Path,
                _function: requestBody._function,
                _class: requestBody._class,
            };
        }
        return MainServices.post(MainServices.url + this.aiurl, newRequestBody, {
            noCredentials: true,
        }).then(() => this.getResponse(guid))
    }

    runCommandFreeForm(text, model, callBackParamsl = () => { }) {
        const requestBody = {
            model,
            text,
            _class: "SqreemNlp",
            _function: "VertexNlpRaw",
            data: {
                parameters: {
                    temperature: 0.3,
                    maxOutputTokens: 1024,
                    topP: 0.8,
                    topK: 1
                }
            }
        }
        callBackParamsl(requestBody)
        return this.runAPi(requestBody).then((response) => {
            try {
                const { results } = response.data[0];
                return results.predictions[0].content
            } catch (error) {
                return "{}"
            }
        })
    }

    getGenderAgeDistribution(text, monitorObj) {
        return fetch(GenderAgeModel).then((response) => response.text()).then((modelText) => {
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor(monitorObj)
            let url = MainServices.url + this.aiurl
            const callBackParamsl = (params) => {
                startMonitor(params, { url })
            }
            return this.runCommandFreeForm(text, modelText, callBackParamsl).then((resp) => {
                try {
                    let newResp = JSON.parse(resp.replace(/\\/g, ''))
                    endMonitor(newResp, { url })
                    return newResp
                } catch (error) {
                    endMonitor(error, { url })
                    return null
                }
            })
        })
    }
}

export default new SqreemAIServices();
